import { combineReducers } from 'redux';

import reqAllUsers from './reqAllUsers';
import reqRelatedUsers from './reqRelatedUsers';
import reqNewChannel from './reqNewChannel';
import reqSocialChannel from './reqSocialChannel';
import reqAssignPatient from './reqAssignPatient';
import reqChangeChatName from './reqChangeChatName';
import reqAssignProvider from './reqAssignProvider';
import reqChannels from './reqChannels';
import reqChannel from './reqChannel'; // channelWithinNextPage
import reqCircleOfCare from './reqCircleOfCare';
import reqFilters from './reqFilters';
import reqInvitePatient from './reqInvitePatient';
import reqMetadata from './reqMetadata';

import channels from './channels';
import circleOfCare from './circleOfCare';
import filters from './filters';
import inviteForm from './inviteForm';
import metadata from './metadata';
import replies from './replies';
import settings from './settings';
import reqChannelParticipants from './reqChannelParticipants';
import reqAddParticipants from './reqAddParticipants';
import reqRemoveParticipant from './reqRemoveParticipant';
import reqBlockUser from './reqBlockUser';
import reqUnblockUser from './reqUnblockUser';
import blockUserForDependent from './block-user-for-dependent';
import createChatInboxTask from './create-chat-inbox-task-req';
import unblockUserForDependent from './unblock-user-for-dependent';
import dependentChannelParticipants from './dependent-channel-participants';
import relationshipPriority from './reqRelationshipPriority';

export default combineReducers({
  reqAllUsers,
  reqRelatedUsers,
  reqNewChannel,
  reqSocialChannel,
  reqChannels,
  reqChannel,
  reqCircleOfCare,
  reqFilters,
  reqInvitePatient,
  reqAssignPatient,
  reqChangeChatName,
  reqAssignProvider,
  reqMetadata,

  channels,
  circleOfCare,
  filters,
  inviteForm,
  metadata,
  replies,
  settings,
  reqChannelParticipants,
  reqAddParticipants,
  reqRemoveParticipant,
  reqBlockUser,
  reqUnblockUser,
  createChatInboxTask,
  blockUserForDependent,
  unblockUserForDependent,
  dependentChannelParticipants,
  relationshipPriority,
});



// WEBPACK FOOTER //
// ./src/redux/board/index.js